import { render } from "./ProjectRazzo.vue?vue&type=template&id=070739c3"
import script from "./ProjectRazzo.vue?vue&type=script&lang=js"
export * from "./ProjectRazzo.vue?vue&type=script&lang=js"

import "./ProjectRazzo.vue?vue&type=style&index=0&id=070739c3&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__